<template>
  <nullable-radio-group
    :labels="labels"
    :loading="cloudCannonContentLoading"
    :name="`${attestation.attestations.toLowerCase()}Yay`"
    @change="onNRGChange"
  />
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { useStore } from '@vue3shims';
import NullableRadioGroup from '@molecules/NullableRadioGroup.vue';

export default {
  emits: ['choice-made'],
  props: {
    attestation: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const choice = ref(null);
    const store = useStore();
    const cloudCannonContent = computed(() => store.getters['cloudCannon/cloudCannonContent']);
    const cloudCannonContentLoading = computed(() => store.getters['cloudCannon/cloudCannonContentLoading']);
    const perm = computed(() => props.attestation.attestations.toLowerCase());
    const labels = computed(() => {
      return {
        yes: cloudCannonContent.value.attestations[props.attestation.attestations.toLowerCase()].attestation_confirm,
        no: cloudCannonContent.value.attestations[props.attestation.attestations.toLowerCase()].attestation_decline,
      }
    });
    const onNRGChange = (e) => {
      choice.value = e.value ? 'yay' : 'nay';
      emit('choice-made', {perm: perm.value, value: e.value });
    }

    return {
      cloudCannonContent,
      cloudCannonContentLoading,
      labels,
      onNRGChange,
    }
  },
  components: {
    NullableRadioGroup,
  }
}
</script>

<style scoped>
#choices {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  width: 100%;
}

.choice {
  align-items: center;
  display: flex;
  justify-content: left;
  width: 100%;
}
</style>